const usersValidator = {
	name: {
		rules: [
			{
				test: /.*/,
				message: 'Please Enter Valid Name',
			},
            {
                test: (value) => {
                    return value.length >= 1;
                },
                message: 'can not be less then 1 character',
            },
		],
		errors: [],
		valid: false,
		state: '',
	},
	email: {
		rules: [
			{
				test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
				message: 'Please Enter Valid Email',
			},
            {
                test: (value) => {
                    return value.length >= 1;
                },
                message: 'can not be less then 1 character',
            },
		],
		errors: [],
		valid: false,
		state: '',
	},
	phoneNumber: {
		rules: [
			{
				test: /^[+0-9]+$/,
				message: 'Please enter valid phone number',
			}
		],
		errors: [],
		valid: false,
		state: '',
	},
	password: {
		rules: [
			{
				test: (value) => {
					return value.length >= 6;
				},
				message: 'Password can not be < 6 characters',
			},
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Enter Valid Password',
			},
		],
		errors: [],
		valid: false,
		state: ''
	},
	repeatPassword: {
		rules: [
			{
				test: (value) => {
					return value.length >= 6;
				},
				message: 'Password can not be < 6 characters',
			},
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Enter Valid Password',
			},
		],
		errors: [],
		valid: false,
		state: ''
	},
	isPasswordEqual: {
		rules: [
			{
				test: (value) => {
					return value.prev === value.next;
				},
				message: 'Passwords are not equal'
			},
		],
		errors: [],
		valid: false,
		state: ''
	},
	status: {
		rules: [
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Please select valid status',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	role: {
		rules: [
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Please select valid role',
			},
		],
		errors: [],
		valid: false,
		state: '',
	},
	companyId: {
		rules: [
			{
				test: /^[a-z0-9A-Z_]+$/,
				message: 'Please select valid organisation',
			},
		],
		errors: [],
		valid: false,
		state: '',
	}
};

export default usersValidator;



// WEBPACK FOOTER //
// ./src/helpers/usersValidator.js